<template>
  <div>
    <div class="button-group-wrapper">
      <b-row >
        <b-col sm="6" lg="4">
          <div class="button-box shadow">
            <router-link to="/gebaeude/erstellen" class="custom-button">
              <div class="button-box-body">
                <a class="icon-lg rounded-circle">
                  <span class="icon-add"></span>
                </a>
              </div>
              <div class="button-legend">Gebäude</div>
            </router-link>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="main-box">
      <h1>Gebäude</h1>

      <b-alert v-model="hasUnknownError" variant="danger">
        {{ $t('formError.unknownwError') }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger">
        {{ errorMessage }}
      </b-alert>

      <dx-data-grid
        :data-source="items"
        :showColumnLines="false"
        :showRowLines="true"
        key-expr="liegenschaftId"
        :selection="{ mode: 'single' }"
        :hover-state-enabled="true"
        :column-auto-width="true"
        @selection-changed="onRowSelected"
        noDataText="Keine Einträge"
        :wordWrapEnabled="true"
        ref="myDataGrid"
      >
        <dx-header-filter
          :visible="true"
        />
        <dx-filter-row
          :visible="true"
        />
        <dx-search-panel
          :visible="true"
          :width="240"
          placeholder="Gebäude suchen"
        />
        <dx-column
          data-field="gebaeudeartBezeichnung"
          caption="Gebäudeart"
        />
        <dx-column
          data-field="adresse"
          caption="Adresse"
        />
        <dx-column
          data-field="nutzungsartBezeichnung"
          caption="Nutzungsart"
        />
        <dx-column
          data-field="parzellenNr"
          caption="Parzellen Nr."
        />
        <dx-column
          v-if="isOrganisationAccount"
          data-field="createdUserEmail"
          caption="Ersteller"
        />
        <dx-column
          caption=""
          cell-template="button-template"
          width="60px"
          type="buttons"
          :fixed="true"
          :showInColumnChooser="false"
        />
        <template #button-template="{ data }">
          <div v-if="!isOrganisationAccount || (isOrganisationAccount && currentUser.email === data.data.createdUserEmail)">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <span class="icon-more_vert"></span>
              </template>
              <b-dropdown-item :to="`/gebaeude/${data.data.liegenschaftId}/bearbeiten`">Bearbeiten</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="deleteProperty(data.data.liegenschaftId)">Löschen</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <dx-paging
          :pageSize="pageSize"
          :page-index="pageIndex"
          @update:pageIndex="onPageChange($event)"
        />

      </dx-data-grid>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'
  import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxPaging
  } from 'devextreme-vue/data-grid'

  export default {
    data: () => ({
      hasUnknownError: false,
      hasError: false,
      errorMessage: '',
      pageSize: 10,
      pageIndex: 0
    }),
    created () {
      this.getProperties()
    },
    beforeUpdate () {
      const page = this.$route.query.page || 1
      this.onNavigatePage(page)
    },
    methods: {
      async getProperties () {
        this.isBusy = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('property/GET_MY_PROPERTIES').then(res => {
          this.isBusy = false
          const { errors } = res

          if (errors) {
            this.isBusy = false
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isBusy = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      async deleteProperty (propertyId) {
        this.$bvModal.msgBoxConfirm('Möchten Sie dieses Gebäude wirklich löschen?', {
          title: 'Löschen',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Ja',
          cancelTitle: 'Nein',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              this.hasUnknownError = false
              this.hasError = false

              this.$store.dispatch('property/DELETE_PROPERTY', propertyId).then(res => {
                this.isBusy = false
                const { errors } = res

                if (errors) {
                  return errorHandler(this, errors)
                }
              }).catch(err => {
                this.hasUnknownError = true
                console.error(err)
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
      },
      onRowSelected ({ selectedRowsData }) {
        const { liegenschaftId: propertyId, createdUserEmail } = selectedRowsData[0]
        if (!this.isOrganisationAccount || (this.isOrganisationAccount && this.currentUser.email === createdUserEmail)) {
          this.$router.push({
            name: 'property-detail',
            params: {
              propertyId
            }
          }).catch((e) => {})
        }
      },
      onPageChange (value) {
        this.onNavigatePage(value + 1)
      },
      onNavigatePage (page) {
        this.pageIndex = Number(page - 1)

        this.$router.push({
          query: { page: Number(page) }
        }).catch(() => {})
      }
    },
    watch: {
      $route (to) {
        const toPage = to.query.page || 1
        this.onNavigatePage(toPage)
      }
    },
    computed: {
      ...mapGetters({
        items: 'property/MY_PROPERTIES',
        currentUser: 'user/CURRENT_USER'
      }),
      ...mapState({
        isOrganisationAccount: state => state.user.currentUser.isOrganisationAccount
      })
    },
    components: {
      DxDataGrid,
      DxColumn,
      DxHeaderFilter,
      DxSearchPanel,
      DxFilterRow,
      DxPaging
    }
  }
</script>

<style lang="scss" scoped>
  .search-col{
    padding-left: 0;
    padding-right: 0;
  }
  .table-btns a {
    line-height: 1;
  }
  .icon-delete, .icon-edit{
    cursor: pointer;
  }
  .icon-more_vert{
    font-size: $font-size-lg * 1.5;
  }
</style>
